import { IdentityService } from './../../../core/services/identity.service';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BalanceService } from 'src/app/core/services/balance.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-cvu-view',
  templateUrl: './cvu-view.component.html',
  styleUrls: ['./cvu-view.component.scss']
})
export class CvuViewComponent implements OnInit {
  @ViewChild('cvuInput', { static: true }) cvuInput: ElementRef;
  @ViewChild('aliasInput', { static: true }) aliasInput: ElementRef;
  @Input() isMobile: boolean = false;

  aliasInfo: any;
  cbuInfo: any;
  tipoCuenta: any;
  isVisible: boolean = false;
  isCommerce: boolean;

  fecha: Date = new Date();

  currentUser: any;
  nameLastName: string;
  cuilCuit: string;

  constructor(
    private balanceService: BalanceService,
    private notificationService: NotificationService,
    private router: Router,
    private identity: IdentityService
  ) {}

  async ngOnInit() {
    this.isCommerce = this.identity.isCommerce();
    if (this.isCommerce) {
      this.currentUser = this.identity.getUserOrganism();
      this.nameLastName = this.currentUser.nombre;
      this.cuilCuit = this.maskCuit(this.currentUser.numeroDocumento);
    } else {
      this.currentUser = this.identity.getUser().persona;
      this.nameLastName = `${this.currentUser.nombres} ${this.currentUser.apellido}`;

      this.cuilCuit = this.maskCuit(String(this.currentUser.nroDocumento));
    }

    const bankInfo =
      localStorage.getItem('bankInfo') !== null
        ? JSON.parse(localStorage.getItem('bankInfo'))
        : <AccountInfo>await this.balanceService.cashIn();
    this.aliasInfo = bankInfo.alias;
    this.cbuInfo = bankInfo.cbu;
    this.tipoCuenta = bankInfo.tipoCuenta;
  }

  maskCuit(cuit: string) {
    return cuit.length > 8
      ? cuit.substring(0, 2) + '-' + cuit.substring(2, 10) + '-' + cuit.substring(10)
      : cuit.substring(0, 2) + '.' + cuit.substring(2, 5) + '.' + cuit.substring(5);
  }

  copyCvu() {
    if (this.cvuInput) {
      this.cvuInput.nativeElement.select();
      document.execCommand('copy');
      this.cvuInput.nativeElement.setSelectionRange(0, 0);
      this.notificationService.showSuccess('CVU copiado en el portapapeles');
    }
  }

  copyAlias() {
    if (this.aliasInput) {
      this.aliasInput.nativeElement.select();
      document.execCommand('copy');
      this.aliasInput.nativeElement.setSelectionRange(0, 0);
      this.notificationService.showSuccess('ALIAS copiado en el portapapeles');
    }
  }

  currentUrl() {
    if (this.router.url == '/user/deposit-money') {
      return false;
    } else {
      return true;
    }
  }

  print(): void {
    window.print();
  }

  goBack() {
    let url = localStorage.getItem('url');
    this.navigate(url);
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }
}

interface AccountInfo {
  alias: string;
  cbu: string;
  ingresoRapipago: boolean;
  tipoCuenta: string;
}
